import mapNestedNotifications from '../mapNestedNotifications'

export default function(data) {
  return {
    conflictedCounter: data.conflictedCounter,
    counter: data.counter,
    id: data.id,
    notifications: mapNestedNotifications(data.notifications),
  }
}
